import {
  AgentSavedDashboardItemSchema,
  AgentSavedDashboardItemsResponseSchema,
  type AgentSavedDashboardItem,
  type AgentSavedDashboardItemsResponse,
  type CreateAgentSavedDashboardItemInput,
  type ReorderAgentSavedDashboardItemsInput,
} from '@magimp/shared';
import { request } from '../client.js';

const BASE = '/dashboards/agent/v2/saved-dashboard';

export function listAgentSavedDashboardItems(): Promise<AgentSavedDashboardItemsResponse> {
  return request(BASE, { method: 'GET' }, {}, AgentSavedDashboardItemsResponseSchema);
}

export function pinAgentSavedDashboardItem(
  input: CreateAgentSavedDashboardItemInput,
): Promise<AgentSavedDashboardItem> {
  return request(`${BASE}/items`, jsonInit('POST', input), {}, AgentSavedDashboardItemSchema);
}

export function reorderAgentSavedDashboardItems(
  input: ReorderAgentSavedDashboardItemsInput,
): Promise<AgentSavedDashboardItemsResponse> {
  return request(
    `${BASE}/reorder`,
    jsonInit('PATCH', input),
    {},
    AgentSavedDashboardItemsResponseSchema,
  );
}

export function deleteAgentSavedDashboardItem(id: string): Promise<void> {
  return request(`${BASE}/items/${id}`, { method: 'DELETE' });
}

function jsonInit(method: string, body: unknown): RequestInit {
  return {
    method,
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  };
}
